import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import "./VehicleImage.scss";

let VehicleImage = ({ image, size, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const src = image ? (size === "full" ? image.url_full : image.url_thumbnail) : "";
  const resolvedAlt = alt || (image && image["legal_info"]);

  useEffect(() => {
    if (src) setIsLoaded(false);
  }, [src]);

  if (!image) return null;

  const imgClasses = `img-fluid${isLoaded ? "" : " img-loading"}`;

  return (
    <span className="VehicleImage">
      {!isLoaded && (
        <div className="loading-overlay">
          <LoadingSpinner />
        </div>
      )}
      <img
        src={src}
        alt={resolvedAlt}
        className={imgClasses}
        onLoad={() => setIsLoaded(true)}
        onError={() => setIsLoaded(true)}
      />
    </span>
  );
};

export default VehicleImage;

VehicleImage.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  size: PropTypes.string
};
